module.exports = __webpack_public_path__ + "media/images/desvantagens-4fcf4a2f80de4078741ce7bff7927475.svg";